import { AppThunk } from '../states/generateStore';
import { suiteCrmUrl, getLeadSource } from './constants';
import shellSlice from '../states/shell/slice';
import snackBarSlice from '../states/snackbar/slice';

const onGetLeadSource = (): AppThunk => 
    async (dispatch, getStore) => {
        const name = 'lead_source_dom';
        // Create a fetch call to get sms template
        try {
        const formData = new FormData();
        formData.append('name', name);

        const response = await fetch(suiteCrmUrl.concat(getLeadSource),
            { 
            method: 'POST',
            body: formData
            }
        );
        const result = await response.json();
        if (result) {
            let keysArray = Object.keys(result);
            let mappingArr = keysArray.map((item: any) => {
                return {
                    value: item,
                    label: result[item]
                }
            });
            dispatch(shellSlice.actions.updateLeadSource(mappingArr));
        }
        } catch (err) {
        console.log(err);
        // show error
        dispatch(snackBarSlice.actions.updateAlert({message: "onGetLeadSource: Can not get data from Server", severity: "error"}));
        dispatch(snackBarSlice.actions.updateSnackBar(true));
        }
    }
export default onGetLeadSource;